<script setup lang="ts">
//#region types
interface Props {
  tooltip?: string
  color?: string
  customClass?: string
  disabled?: boolean
  isOverlay?: boolean
  size?: number
  routerTo?: any | null
  icon: string
}

interface  Emits {
  'click': [event: MouseEvent],
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  tooltip: '',
  color: 'var(--text-primary)',
  customClass: '',
  disabled: false,
  isOverlay: true,
  size: 12,
  routerTo: null,
});
const emit = defineEmits<Emits>();
//#endregion

const handleClick = (event: MouseEvent) => {
  if (props.disabled) return;

  emit('click', event);
};
</script>

<template>
  <UiTooltip
    :tooltip="tooltip"
    :disabled="disabled"
  >
    <component
      :is="routerTo ? 'RouterLink' : 'div'"
      :to="routerTo"
      :class="[
        'action-ico',
        customClass,
        {'action-ico_disabled': disabled},
        {'action-ico_overlay': isOverlay}
      ]"
      @click="handleClick"
    >
      <slot>
        <UiIcon
          :name="icon"
          :color="color"
          :size="size"
        />
      </slot>
    </component>
  </UiTooltip>
</template>

<style lang="scss">
.action-ico{
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border-radius: 50%;
  background-color: transparent;
  outline: none;
  z-index: 1;

  &_overlay {
    width: 28px;
    height: 28px;
    &:hover {
      background-color: rgba(0, 0, 0, .1);
    }
  }
  &:hover {
    cursor: pointer;
  }
  &_disabled {
    i{
      opacity: .3;
    }
    &:hover {
      cursor: default;
      background-color: transparent;
    }
  }
}

</style>
